module.exports = __webpack_public_path__ + "ath_game_web/img/concepts05.002d121b.png";